export const NEW_USER_REGISTRATION_MESSAGE = 'NEW_USER_REGISTRATION_MESSAGE';
